import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';

function LoginForm({ username, password, onChangeUser, onChangePassword }){
	return (
		<>
			<Row>
				<Col xs={12} md={12}>
					<Form>
						<h2 className="mb-4">NPE - Tools System</h2>
						<Form.Group controlId="formBasicEmail">
							<Form.Label>Usuário</Form.Label>
							<Form.Control
								type="text"
								placeholder="Usuário"
								value={username}  // Define o valor do campo com base no estado
								onChange={(e) => { 
									e.target.value = e.target.value.toUpperCase() 
									onChangeUser(e.target.value) 
								}}
							/>
						</Form.Group>
						<Form.Group controlId="formBasicPassword">
							<Form.Label>Password</Form.Label>
							<Form.Control
							type="password"
							placeholder="Password"
							value={password}
							onChange={(e) => onChangePassword(e.target.value)}
							/>
						</Form.Group>
					</Form>
				</Col>
			</Row>
		</>   
	);
};

export default LoginForm;
